var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getWithRetries } from "../../http.mjs";
import { orderFromStripePaymentIntentResponseSchema } from "../../psp/stripe/schema.mjs";
import { logger } from "../../log.mjs";
import { customerElementId, expressCheckoutElementId, initializeStripeElements, paymentElementId } from "./elements.mjs";
export const initializeStripeIfNeeded = (state, actions) => __awaiter(void 0, void 0, void 0, function* () {
    checkForPaymentIntentRedirect(state, actions);
    const cartCheckout = state.checkout;
    if (!cartCheckout) {
        return;
    }
    const cartPayment = cartCheckout === null || cartCheckout === void 0 ? void 0 : cartCheckout.payment;
    if ((cartPayment === null || cartPayment === void 0 ? void 0 : cartPayment.$type) !== 'stripeCheckout') {
        removeStripeElementsIfNeeded(state);
        return;
    }
    if (cartPayment.elements.status.$type === 'complete') {
        removeStripeElementsIfNeeded(state);
        actions.clearCartAndShowOrderConfirmation(cartPayment.elements.status.orderId);
        return;
    }
    addStripeElementsIfNeeded(state);
    initializeStripeElements(state, actions, cartCheckout, cartPayment);
});
const checkForPaymentIntentRedirect = (state, actions) => __awaiter(void 0, void 0, void 0, function* () {
    const url = new URL(window.location.href);
    const paymentIntentId = url.searchParams.get('payment_intent');
    if (paymentIntentId) {
        try {
            const response = yield getWithRetries(`/stripe/payments/intents/${paymentIntentId}`, state.checkoutApiBaseUrl, orderFromStripePaymentIntentResponseSchema, state.token);
            actions.clearCartAndShowOrderConfirmation(response.orderId);
        }
        catch (error) {
            logger.error({ error }, 'Error when fetching order from payment intent');
            state.onUnexpectedError('Error when fetching order from Stripe payment');
        }
    }
});
const addStripeElementsIfNeeded = (state) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { stripeCheckoutSet, stripeExpressSet } = stripeElementsAreSet(state);
    const shouldSetExpress = expressCheckoutAllowed(state) && !stripeExpressSet;
    if (!stripeCheckoutSet || shouldSetExpress) {
        state.update({
            checkoutElements: Object.assign(Object.assign({}, state.checkoutElements), { takeover: Object.assign(Object.assign({}, (((_a = state.checkoutElements.takeover) === null || _a === void 0 ? void 0 : _a.type) === 'partial' ? state.checkoutElements.takeover : {})), { type: 'partial', paymentElementId: paymentElementId, customerElementId: customerElementId }), express: {
                    payNowElementId: expressCheckoutAllowed(state) ? expressCheckoutElementId : undefined,
                } }),
        });
    }
});
// We only allow express checkout if we know your postal code
// because otherwise we can't calculate the correct prices
const expressCheckoutAllowed = (state) => {
    var _a, _b;
    const validPostalCode = (_b = (_a = state.customer.address) === null || _a === void 0 ? void 0 : _a.postalCode) === null || _b === void 0 ? void 0 : _b.trim().length;
    return !!validPostalCode && state.validCountryCode && state.validCurrency;
};
const removeStripeElementsIfNeeded = (state) => __awaiter(void 0, void 0, void 0, function* () {
    const { stripeCheckoutSet, stripeExpressSet } = stripeElementsAreSet(state);
    if (stripeCheckoutSet || stripeExpressSet) {
        state.update({
            checkoutElements: Object.assign(Object.assign({}, state.checkoutElements), { takeover: undefined, express: undefined }),
        });
    }
});
const stripeElementsAreSet = (state) => {
    var _a, _b;
    return {
        stripeCheckoutSet: ((_a = state.checkoutElements.takeover) === null || _a === void 0 ? void 0 : _a.type) === 'partial' &&
            state.checkoutElements.takeover.paymentElementId === paymentElementId &&
            state.checkoutElements.takeover.customerElementId === customerElementId,
        stripeExpressSet: ((_b = state.checkoutElements.express) === null || _b === void 0 ? void 0 : _b.payNowElementId) === expressCheckoutElementId,
    };
};
//# sourceMappingURL=index.js.map